<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-alert v-for="(errors, id) in response.errors" :key="id" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
            <p v-if="response.errors" style="font-size:13px;margin-bottom: 0;"><b>{{ id }}</b> : <span v-for="(error, index) in errors" :key="index"><br>{{ error }}</span></p>
           <strong v-if="!response.errors">{{response.message}}</strong>
      </b-alert>
      <b-alert v-if="!response.errors" :show="dismissCountDown"
                dismissible
                :variant="response.success== true ? 'success':'danger'"
                @dismissed="dismissCountdown=0"
                @dismiss-count-down="countDownChanged">
          <strong v-if="!response.errors">{{response.message}}</strong>
      </b-alert>
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4" v-if="isConnect">
              <b-card-body class="text-center no-padding">
                <div>
                  <p class="time-title">Vous serez connecté dans </p>
                  <span class="time-left">{{remaingTime}}</span>
                  <p class="time-title">secondes</p>
                  
                </div>
              </b-card-body>
            </b-card>
            <b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="background-color: #215aa9 !important;width:44%" v-if="!isConnect">
              <b-card-body class="text-center no-padding">
                <div>
                  <p class="time-title"></p>
                  <span class="time-left">Vous êtes déconnecté !</span>
                  <p class="time-title"></p>
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import router from '../../router'
export default {
  name: 'SecretCode',
  data(){
    return {
      isConnect:false,
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      response:{},
      code:'',
      remaingTime: 181,
      timeout:null
    }
  },
  mounted(){
    //console.log('je monte le store',this.$store.getters['auth/userPermissions'])
  },
  methods:{
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    checkSecretCode(){
      
      this.$store.dispatch('auth/login_step_keycloak',{
        code: '1234'
      })
      .then(async(response) =>{
        console.log('redirection vers le dashboard')
        await router.push({
            name: 'Dashboard', 
            params: { reload_option: true }
        }).catch((err) => {
          console.log('Erreur lévée ',err)
        });
        // this.$router.replace({ 
        //   name: 'Dashboard',
        //   params: { reload_option: true }
        // }).catch(err => {
        //   console.log('all good')
        // })
      })
      .catch(error=>{

        this.response.message = error.response.data.message
        //this.response.message = "dd"
        this.showAlert()
        return
      })
    },
    verif_info(){
      if(localStorage.getItem('token')){
          this.isConnect = true
      }else{
          this.isConnect = false
      } 
    },
    logout_timer(){
      this.remaingTime--
      if(this.remaingTime > 0){        
      //this.remaningTime < 30 && 
        this.timeout = setTimeout(this.logout_timer, 1000)
      }else {
        //On se déconnecte
        this.$router.push({name:'Logout'})
        console.log('About to be disconnected')
      }
    },    
    logout(){
      this.$router.push({name:'Logout'})
    }
  },
  computed:{
    // get_user(){
    //   return this.$store.getters['auth/get_user'].username
    // }
  },

  mounted(){
    this.verif_info()
    this.logout_timer()
    this.checkSecretCode()
  }, 

  beforeDestroy(){
    clearTimeout(this.timeout)
  }
}
</script>

<style>
  .time-left {
    font-size: 96px;
  }

  .time-title {
    margin: 0;
  }

  .no-padding {
    padding: 0;
  }
</style>

